export default __webpack_public_path__ + "assets/menu-close_white.e5728842.svg";